import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import DashboardLogin from "../components/DashboardLogin";
import MandateDashboard from "../components/MandateDashboard";
import { exchangeDashboardSession, getDashboardUser } from "../lib/api";
import "./MandateDashboardPage.css";

export default function MandateDashboardPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const processedSession = useRef(false);
  const [user, setUser] = useState(null);
  const [isChecking, setIsChecking] = useState(true);
  const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");

  useEffect(() => {
    const checkSession = async () => {
      if (sessionId) {
        if (processedSession.current) return;
        processedSession.current = true;
        try {
          const result = await exchangeDashboardSession(sessionId);
          setUser(result.user);
          navigate("/mandats", { replace: true });
        } catch (error) {
          const message = error.response?.status === 403
            ? "Ce compte Google n’est pas autorisé."
            : "La connexion Google n’a pas pu être vérifiée.";
          toast.error(message);
          navigate("/mandats", { replace: true });
        } finally {
          setIsChecking(false);
        }
        return;
      }
      try {
        setUser(await getDashboardUser());
      } catch {
        setUser(null);
      } finally {
        setIsChecking(false);
      }
    };
    checkSession();
  }, [navigate, sessionId]);

  const startLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = `${window.location.origin}/mandats`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (isChecking) {
    return <main className="mandate-auth" data-testid="mandate-dashboard-checking">Vérification d’accès…</main>;
  }
  if (!user) return <DashboardLogin onLogin={startLogin} />;
  return <MandateDashboard user={user} onLogout={() => setUser(null)} />;
}